// extracted by mini-css-extract-plugin
export default {"loader_container":"UserData_loader_container__VcGq-"};